import { writable } from 'svelte/store';
import type { QueriesType, QueryType } from '../lib/components/telematics/types';

export type FilterListType = {
    queries: QueriesType;
    quickSearch: string;
    managerStorageKey: string;
    onlyLowQuality?: boolean;
};

export type FilterType = {
    vehicles: {
        query: string;
        onlyEnabled: boolean;
    };
    jobsToBeCompleted: FilterListType;
    connections: {
        queries: QueriesType;
        quickSearch: string;
        managerStorageKey: string;
    };
    planning: {
        simpleView: boolean;
        onlyNotReady: boolean;
        driverName: string;
    };
    tacticalPlan: {
        query: string;
    };
    warehouses: {
        query: string;
    };
    maps: {
        query: string;
    };
    dashboard: {
        queries: QueriesType;
        managerStorageKey: string;
    };
    accounts: {
        query: string;
    };
};

export const filter = writable<FilterType>({
    vehicles: {
        query: '',
        onlyEnabled: false,
    },
    jobsToBeCompleted: {
        onlyLowQuality: false,
        queries: {},
        quickSearch: '',
        managerStorageKey: 'filterManager.jobs',
    },
    connections: {
        queries: {},
        quickSearch: '',
        managerStorageKey: 'filterManager.connections',
    },
    planning: {
        simpleView: false,
        onlyNotReady: false,
        driverName: '',
    },
    tacticalPlan: {
        query: '',
    },
    warehouses: {
        query: '',
    },
    maps: {
        query: '',
    },
    dashboard: {
        queries: {},
        managerStorageKey: 'filterManager.dashboard',
    },
    accounts: {
        query: '',
    },
});

export const currentMainFilter = writable<any>(null);
